import React, { useState, useEffect, useMemo } from 'react';
import { useLatest } from 'react-use';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import RasterHistoryHeatmap from 'components/features/RasterHeatmap/RasterHistoryHeatmap/RasterHistoryHeatmap';
import { mapRecord } from '../../utils/helpers';
import '../HeatmapViewableImagesContainer.css';

function HeatmapViewableImage({
  rasterId,
  donorDevice,
  instance,
  customClassName,
  az,
  el,
  score,
  placeholder,
  handleSingleImageDownload,
  hidePopover
}) {
  const instanceRef = useLatest(instance);
  const deviceHeatmapHistoryDictionary = useSelector((store) => store.data.heatmapHistoryDictionary?.[donorDevice]);
  const getRasterRecordStatusName = `GET-RasterRecord-${rasterId}`;
  const getRasterRecordStatus = useSelector((store) => store.statuses?.[getRasterRecordStatusName]);

  const [localRasterRecord, setLocalRasterRecord] = useState(null);
  const deviceHeatmap = useMemo(() => mapRecord(localRasterRecord), [localRasterRecord]);

  useEffect(() => {
    if (getRasterRecordStatus === Status.SUCCESS && deviceHeatmapHistoryDictionary?.[rasterId]) {
      const newLocalRasterRecord = { ...deviceHeatmapHistoryDictionary[rasterId] };

      if (instanceRef.current?.Timestamp || instanceRef.current?.timestamp) {
        newLocalRasterRecord.ts = instanceRef.current?.Timestamp ?? instanceRef.current?.timestamp;
      }

      setLocalRasterRecord(newLocalRasterRecord);
    }
  }, [instanceRef, getRasterRecordStatus, deviceHeatmapHistoryDictionary, donorDevice, rasterId]);

  const id = `HeatmapViewableImagesContainer_HeatMapDiv_${rasterId || 'NoData'}`;

  return (
    <div
      id={id}
      key={id}
      className={classnames({
        HeatmapViewableImagesContainer_HeatMapDiv: true,
        HeatmapViewableImagesContainer_HeatMapDiv_Placeholder: customClassName !== null
      })}
    >
      <div
        id="HeatmapViewableImagesContainer_HeatMapDiv_Header_Container"
        className="HeatmapViewableImagesContainer_HeatMapDiv_Header_Container"
      >
        <div id="HeatmapViewableImagesContainer_MetricDiv" className="HeatmapViewableImagesContainer_MetricDiv">
          <div
            id="HeatmapViewAbleImagesContainer_MetricDiv_Metric"
            className="HeatmapViewAbleImagesContainer_MetricDiv_Metric"
          >
            Dither Azimuth: {az ?? '00'}
          </div>
          <div
            id="HeatmapViewAbleImagesContainer_MetricDiv_Metric"
            className="HeatmapViewAbleImagesContainer_MetricDiv_Metric"
          >
            Dither Elevation: {el ?? '00'}
          </div>
          <div
            id="HeatmapViewAbleImagesContainer_MetricDiv_Metric"
            className="HeatmapViewAbleImagesContainer_MetricDiv_Metric"
            data-tip={'The average of the top 15 heatmap values'}
          >
            Score: {score ?? '00'}
          </div>
        </div>
        {!placeholder && (
          <div id="HeatmapViewableImagesContainer_ExportDiv" className="HeatmapViewableImagesContainer_ExportDiv">
            <div
              id={`HeatmapViewableImagesContainer_ExportDiv_ExportBtn_${rasterId}`}
              className="HeatmapViewableImagesContainer_ExportDiv_ExportBtn"
              onClick={() => localRasterRecord && handleSingleImageDownload(localRasterRecord)}
              data-tip={'Export Image'}
            >
              <img src={IconLoader.icon_file_download} alt="" />
            </div>
          </div>
        )}
      </div>
      <RasterHistoryHeatmap
        id={donorDevice}
        forViewAndExportHeatmap={true}
        heatmap={deviceHeatmap}
        beamrank={deviceHeatmap.beamrank}
        selectedDeviceHeatmapRecord={localRasterRecord}
        selectedDeviceHeatmapRasterId={rasterId}
        hidePopover={hidePopover}
        placeholder={placeholder}
        showLegend={true}
      />
    </div>
  );
}

export default HeatmapViewableImage;
